import React from "react";
import { css } from "glamor";
import { spacing } from "../../library/theme";

const containerClass = css({
  marginBottom: spacing.l,
});

const topLineClass = css({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: 10,
  marginBottom: spacing.xs,
});

const titleClass = css({
  fontSize: 13,
  fontWeight: 700,
  lineHeight: "19.5px",
  color: "#0f172a",
  margin: 0,
});

const badgeClass = css({
  display: "inline-flex",
  alignItems: "center",
  padding: "2px 10px",
  borderRadius: 6,
  border: "0.66px solid #f9a8d4",
  background: "#fdf2f8",
  color: "#9d174d",
  fontSize: 10,
  fontWeight: 500,
  lineHeight: "15px",
  whiteSpace: "nowrap",
});

const metaLineClass = css({
  display: "flex",
  alignItems: "center",
  gap: spacing.s,
  fontSize: 11,
  fontWeight: 500,
  color: "#64748b",
});

const stepCounterClass = css({
  fontSize: 10,
  fontWeight: 500,
  color: "#94a3b8",
  lineHeight: "15px",
});

const stepperClass = css({
  display: "flex",
  alignItems: "center",
  gap: 4,
});

const dotClass = css({
  width: 8,
  height: 8,
  borderRadius: "50%",
  background: "#e2e8f0",
  transition: "background 0.2s, box-shadow 0.2s",
});

const dotActiveClass = css({
  background: "#0369a1",
});

const dotCurrentClass = css({
  background: "#0369a1",
  boxShadow: "0 0 0 3px #bae6fd",
});

const dotConnectorClass = css({
  width: 12,
  height: 1,
  borderRadius: 1,
  background: "#e2e8f0",
});

const dotConnectorActiveClass = css({
  background: "#0369a1",
});

export default function InteractiveHeader({
  question,
  questionNumber,
  totalQuestions,
  currentStep,
  totalSteps,
}) {
  const hasStep = totalSteps > 0;

  return (
    <div className={containerClass}>
      <div className={topLineClass}>
        {totalQuestions > 0 && (
          <p className={titleClass}>
            Questão {questionNumber} de {totalQuestions}
          </p>
        )}
        <span className={badgeClass}>Questão interativa</span>
      </div>

      <div className={metaLineClass}>
        <span>CÓD: #{question?.id}</span>
        {hasStep && (
          <>
            <div className={stepperClass}>
              {Array.from({ length: totalSteps }).map((_, i) => (
                <React.Fragment key={i}>
                  {i > 0 && (
                    <div
                      className={css(
                        dotConnectorClass,
                        i < currentStep && dotConnectorActiveClass
                      )}
                    />
                  )}
                  <div
                    className={css(
                      dotClass,
                      i < currentStep && dotActiveClass,
                      i === currentStep - 1 && dotCurrentClass
                    )}
                  />
                </React.Fragment>
              ))}
            </div>
            <span className={stepCounterClass}>
              Etapa {currentStep}/{totalSteps}
            </span>
          </>
        )}
      </div>
    </div>
  );
}
